import { useEffect, useState } from 'react';
import { makeBEM, convertDatePickerValueToLocal, initializeMonthPicker } from '../global/utils';

export default function BudgetTimeMachine({dateChangeFn=false, initDate=initializeMonthPicker()}) {
    const moduleName = 'budget-time-machine';
    const [targetDate, setTargetDate] = useState( initializeMonthPicker() );

    useEffect(() => {
        setTargetDate(initDate);
    }, [initDate]);

    const dateChange = (e) => {
        const { value } = e.target;
        const targetDate = convertDatePickerValueToLocal(value);
 
        if ( dateChangeFn ) {
            dateChangeFn(targetDate)
        }
    }

    return (
        <div className={moduleName}>
            <div className={makeBEM(moduleName, 'date-picker-wrapper')}>
                <input 
                    className={makeBEM(moduleName, 'target-date')}
                    type="month" 
                    name="target_date" 
                    value={targetDate}
                    onChange={dateChange}
                />
            </div>
        </div>
    )
}